/* Maintrade Footer */
(() => {
  if (customElements.get('mt-footer')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class MtFooter extends HTMLElement {
    connectedCallback() {
      // Country / language selectors submit as soon as a new option is picked
      this.querySelectorAll('[data-loc-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.closest('form');
          if (form) form.submit();
        });
      });

      this.initReveal();
    }

    initReveal() {
      if (this.dataset.reveal !== 'true') return;

      // Show everything straight away in the theme editor, with reduced motion, or without IntersectionObserver
      if (
        (window.Shopify && window.Shopify.designMode) ||
        reduceMotion.matches ||
        !('IntersectionObserver' in window)
      ) {
        this.classList.add('is-visible');
        return;
      }

      // Hide content only once JS is running, so nothing stays hidden if the script fails
      this.setAttribute('data-ready', '');

      this.io = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.classList.add('is-visible');
            this.io.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  customElements.define('mt-footer', MtFooter);
})();